import { useState } from 'react';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  OutlinedInput,
  Button,
  Divider,
  Grid,
  InputAdornment,
  FormControl,
  FormHelperText,
  Typography,
  Box
} from '@mui/material';
import { useCountdown } from 'hooks/useCountdown';
import { Formik } from 'formik';
import { showError, showSuccess } from 'utils/common';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import useRegister from 'hooks/useRegister';
import { API } from 'utils/api';
import { IconX } from '@tabler/icons-react';

const validationSchema = Yup.object().shape({
  email: Yup.string().email('请输入正确的邮箱地址').required('邮箱不能为空'),
  email_verification_code: Yup.string().required('验证码不能为空')
});

const EmailModal = ({ open, handleClose, turnstileToken, userinfo, updateUserInfo, bind = false }) => {
  const theme = useTheme();
  const { sendVerificationCode } = useRegister();
  const [loading, setLoading] = useState(false);
  const { countdown, isActive, startCountdown } = useCountdown(60);
  const submit = async (values, { setErrors, setStatus, setSubmitting }) => {
    setLoading(true);
    setSubmitting(true);
    const res = await API.get(`/api/oauth/email/bind?email=${values.email}&code=${values.email_verification_code}`);
    const { success, message } = res.data;
    if (success) {
      updateUserInfo(values.email);
      showSuccess('邮箱账户绑定成功！');
      setSubmitting(false);
      setStatus({ success: true });
      handleClose();
    } else {
      showError(message);
      setErrors({ submit: message });
    }
    setLoading(false);
  };

  const handleSendCode = async (email) => {
    if (email === '') {
      showError('请输入邮箱');
      return;
    }

    setLoading(true);
    const { success, message } = await sendVerificationCode(email, turnstileToken);
    setLoading(false);
    if (!success) {
      showError(message);
      return;
    } else {
      startCountdown();
    }
  };

  return (
    <Dialog open={open} style={{ zIndex: 98 }}>
      <DialogTitle sx={{ padding: '0' }}>
        <Box sx={{ padding: '16px 24px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <Typography variant="formTitle" sx={{ textDecoration: 'none', fontSize: '18px' }}>
            绑定邮箱
          </Typography>
          {!bind && <IconX style={{ verticalAlign: 'baseline', color: '#00002280', cursor: 'pointer' }} onClick={handleClose} />}
        </Box>
      </DialogTitle>
      <Divider sx={{ color: '#0000221' }} />
      <DialogContent sx={{ width: 360, padding: '8px 24px 16px 24px' }}>
        <Grid container direction="column" alignItems="center">
          <Formik
            initialValues={{
              email: '',
              email_verification_code: ''
            }}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={submit}
          >
            {({ errors, touched, handleBlur, handleChange, handleSubmit, values }) => (
              <form noValidate onSubmit={handleSubmit}>
                <FormControl
                  fullWidth
                  error={Boolean(touched.email && errors.email)}
                  sx={{ ...theme.typography.customInput, marginBottom: 1.5 }}
                >
                  <OutlinedInput
                    id="email"
                    type="text"
                    value={values.email}
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder="请输入邮箱"
                    sx={{ ...theme.typography.commonInput }}
                  />
                  {touched.email && errors.email && (
                    <FormHelperText error id="helper-email">
                      {errors.email}
                    </FormHelperText>
                  )}
                </FormControl>
                <FormControl
                  fullWidth
                  error={Boolean(touched.email_verification_code && errors.email_verification_code)}
                  sx={{ ...theme.typography.customInput, marginTop: 1 }}
                >
                  <OutlinedInput
                    id="email_verification_code"
                    type="text"
                    value={values.email_verification_code}
                    name="email_verification_code"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    inputProps={{}}
                    endAdornment={
                      <InputAdornment position="end">
                        <Divider orientation="vertical" sx={{ mx: 2, height: '20px', color: '#0000221' }} />
                        <Typography
                          onClick={() => handleSendCode(values.email)}
                          variant="formValue"
                          sx={{ color: theme.palette.primary.main, cursor: 'pointer' }}
                        >
                          {isActive ? `重新发送(${countdown})` : '获取验证码'}
                        </Typography>
                      </InputAdornment>
                    }
                    placeholder="请输入验证码"
                    sx={{ ...theme.typography.commonInput }}
                  />
                  {touched.email_verification_code && errors.email_verification_code && (
                    <FormHelperText error id="helper-email_verification_code">
                      {errors.email_verification_code}
                    </FormHelperText>
                  )}
                </FormControl>
                <DialogActions sx={{ padding: '32px 0 0 0' }}>
                  {!bind && (
                    <Button variant={'CommonBtn'} onClick={handleClose} sx={{ mx: '10px', ...theme.typography.CommonBtn }}>
                      取消
                    </Button>
                  )}
                  <Button disableElevation disabled={loading} type="submit" variant="contained" color="primary">
                    提交
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default EmailModal;

EmailModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func
};
